module.exports = __webpack_public_path__ + "img/game-carousel-3.f4f05dce.png";